<template>
    <div class="accordion-container">
    <!-- <div class="accordion-container">
        <Accordion title="5.1. QR-Code"
            open="true"
            info="Bei Aktivierung der Checkbox erscheint ein QR-Code auf deinem Porträt. Diesen kann man scannen und sich deine Nachricht anhören. Wähle außerdem die Position des QR-Codes."
            ref="addQRCodeAccordion">
            <QRCode></QRCode>
        </Accordion> -->
        <QRCode></QRCode>
    </div>
</template>

<script>
import QRCode from "./QRCode.vue";
import { mapFields } from 'vuex-map-fields';
import Pipeline from "../../../Pipeline/Pipeline";
import AdditionalMessage from "./AdditionalMessage.vue";
import Accordion from "~/scripts/Components/Accordion.vue";

export default {
    components: {
        QRCode,
        Accordion,
        AdditionalMessage
    },
    computed: {
        ...mapFields({
            addQRCode: 'qrcode.use',
            addExtraSound: 'extraSound.use'
        })
    }
};
</script>
